import { Action, createReducer, on } from '@ngrx/store';

import {
    errorStatusModal,
    errorUpdateModal,
    statusModal,
    successStatusModal,
    successUpdateModal,
    updateModal,
} from '../actions/popup.actions';



/**
 * * Modals
*/
interface IEffects {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}
export interface IGetStatusModal extends IEffects {
    status: 0 | 1;
    idCatpopup: number | null;
    descripcion: string | null;
    type: string | null;
    idTenderopopup: number | null;
}
interface IUpdateTenderoModal extends IEffects {

}

export interface ModalState {
    GetStatus: IGetStatusModal;
    UpdateTenderoModal: IUpdateTenderoModal;
}

export const ModalInit: ModalState = {
    GetStatus: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        status: 0,
        idCatpopup: null,
        descripcion: '',
        type: '',
        idTenderopopup: null,
    },
    UpdateTenderoModal: {
        error: null,
        failed: false,
        success: false,
        loading: false
    }
};

const _modalReducer = createReducer(ModalInit,
    on(statusModal, (state) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: true,
                success: false,
                failed: false
            }
        }
    )),
    on(successStatusModal, (state, { data }) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: false,
                success: true,
                status: data.status,
                idCatpopup: data.idCatpopup,
                descripcion: data.descripcion,
                type: data.type,
                idTenderopopup: data.idTenderopopup
            }
        }
    )),
    on(errorStatusModal, (state, { payload }) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: false,
                success: false,
                failed: true,
                error: payload
            }
        }
    )),
    on(updateModal, (state, { }) => (
        {
            ...state,
            UpdateTenderoModal: {
                ...state.UpdateTenderoModal,
                loading: true,
                success: false,
                failed: false
            },
            GetStatus: {
                ...state.GetStatus,
                status: 0,
                idCatpopup: null,
                descripcion: '',
                type: ''
            }
        }
    )),
    on(successUpdateModal, (state, { data }) => (
        {
            ...state,
            UpdateTenderoModal: {
                ...state.UpdateTenderoModal,
                loading: false,
                success: true,
                data
            },
        }
    )),
    on(errorUpdateModal, (state, { payload }) => (
        {
            ...state,
            UpdateTenderoModal: {
                ...state.UpdateTenderoModal,
                loading: false,
                success: false,
                failed: true,
                error: payload
            }
        }
    )),
);

export function ModalReducer(state: ModalState, action: Action): ModalState {
    return _modalReducer(state, action);
}
